
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/natural-language-processing-as-a-service",
      function () {
        return require("private-next-pages/natural-language-processing-as-a-service.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/natural-language-processing-as-a-service"])
      });
    }
  